import { isObject } from 'lodash';

export const MAX_FILE_NAME_LENGTH = 31;

export enum NameError {
  EMPTY = 'Please enter a valid name',
  LENGTH_EXCEEDED = `The name is too long, it should not exceed ${MAX_FILE_NAME_LENGTH} characters`,
  SHOULD_START_WITH_LETTER = 'The name can only start with a letter or a Japanese character',
  INVALID = 'Invalid name',
}

export function validateName(name: string) {
  if (name === '') {
    throw new Error(NameError.EMPTY);
  }

  if (name.length > MAX_FILE_NAME_LENGTH) {
    throw new Error(NameError.LENGTH_EXCEEDED);
  }

  if (!/^[a-zA-Z\u3040-\u30FF\u3400-\u4DBF\u4E00-\u9FAF]/.test(name)) {
    throw new Error(NameError.SHOULD_START_WITH_LETTER);
  }

  if (!/^[\w\u3040-\u30FF\u3400-\u4DBF\u4E00-\u9FAF-]+$/i.test(name)) {
    throw new Error(NameError.INVALID);
  }

  return true;
}

export function validateServerSide(val?: string) {
  if (!val) return null;

  if (typeof val === 'string') {
    try {
      validateName(val);
    } catch (err: any) {
      return err.message;
    }
  }
}

export function validateValue(value: string, type: string) {
  let error = '';

  if (['array', 'object'].includes(type)) {
    try {
      const pValue = JSON.parse(value);

      if (type === 'array' && (!Array.isArray(pValue) || !isObject(pValue))) {
        error = `Invalid value for type ${type}`;
      }

      if (type === 'object' && (!isObject(pValue) || Array.isArray(pValue))) {
        error = `Invalid value for type ${type}`;
      }
    } catch (ex) {
      error = `Invalid value for type ${type}`;
    }
  }

  if (type === 'date') {
    const re = new RegExp(
      /^(0?[1-9]|[12][0-9]|3[01])[/-](0?[1-9]|1[012])[/-]\d{4}$/,
    );
    if (!re.test(value)) {
      error = `Invalid value for type ${type}`;
    }
  }

  if (type === 'number' && isNaN(+value)) {
    error = `Invalid value for type ${type}`;
  }

  if (
    ['boolean', 'bool'].includes(type) &&
    typeof value !== 'boolean' &&
    !['true', 'false'].includes(value)
  ) {
    error = `Invalid value for type ${type}`;
  }

  return error;
}
